export default "__VITE_ASSET__200c66c6__"